import {Injectable} from '@angular/core';

import {ApplicationInsights} from '@microsoft/applicationinsights-web';

@Injectable({
    providedIn: 'root',
  },
)
export class MonitoringService {
  appInsights: ApplicationInsights | undefined;

  constructor() {
    if (S2WX_INSIGHTS_ID) {
      this.appInsights = new ApplicationInsights({
        config: {
          instrumentationKey: S2WX_INSIGHTS_ID,
          enableAutoRouteTracking: true, // option to log all route changes
        },
      });
      this.appInsights.loadAppInsights();
    }
  }

  logPageView(name?: string, url?: string) { // option to call manually
    this.appInsights?.trackPageView({
      name: name,
      uri: url,
    });
    console.log('PageView loaded ', name, url);
  }

  logEvent(name: string, properties?: { [key: string]: unknown }) {
    this.appInsights?.trackEvent({name: name}, properties);
    console.log(name, properties);
  }

  logMetric(name: string, average: number, properties?: { [key: string]: unknown }) {
    this.appInsights?.trackMetric({name: name, average: average}, properties);
  }

  logException(exception: Error, severityLevel?: number) {
    this.appInsights?.trackException({exception: exception, severityLevel: severityLevel});
  }

  logTrace(message: string, properties?: { [key: string]: unknown }) {
    this.appInsights?.trackTrace({message: message}, properties);
    console.log(message, properties);
  }
}
